import React from 'react';
import { Container } from 'reactstrap';

export class PaginationItemGroup extends React.Component {

  MAX_PAGES = 5;

  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);

    const data = [];
    if(Array.isArray(this.props.data) && this.props.data.length > 0)
      data.push(typeof this.props.adapter === 'function' ? this.props.adapter(this.props.data) : this.props.data);

    this.state = {
      currentPage: 0,
      data
    }
  }

  componentWillReceiveProps(nextProps){
    if( Array.isArray(nextProps.data) && nextProps.data.length > 0 && !this.state.data[0] ){

      const data = [];
      if(typeof nextProps.adapter === 'function') {
        data.push(nextProps.adapter(nextProps.data));
      } else if(typeof this.props.adapter === 'function'){
        data.push(this.props.adapter(nextProps.data));
      } else {
        data.push(this.props.data);
      }

      this.setState({
        currentPage: 0,
        data
      });
    }
  }

  changePage(page){

    if(!this.state.data[page]){
      this.props.apiCallFunc( page + 1 )
        .then( response => {
          const data = this.state.data;
          data[page] = typeof this.props.adapter === 'function' ? this.props.adapter(response) : response;

          this.setState(
            {
              currentPage: page,
              data
            },
            () => window.scrollTo(0, 0)
          )
        });
    } else {
      this.setState(
        {
          currentPage: page
        },
        () => window.scrollTo(0, 0)
      )
    }
  }

  render() {
    if(!Array.isArray(this.state.data[this.state.currentPage]))
      return null;

    let items = this.state.data[this.state.currentPage].map((value,index) => {
      return (
        <this.props.item key={ value.id || value.key || index} itemStyle={ this.props.itemStyle || '' } { ...value } />
      );
    });

    let paging = null;

    if(this.props.paging){
      paging = [];
      const lower_limit = Math.max(0, Math.min(this.state.currentPage, +this.props.paging.totalPages - this.MAX_PAGES));
      const upper_limit = Math.min(lower_limit + 5, +this.props.paging.totalPages);

      for(let i = lower_limit; i < upper_limit; i++){
        paging.push(
          <span key={i+1} onClick={() => this.changePage(i)} className={"pagination-item " + ( this.state.currentPage === i ? 'active' : '' )}>{ i + 1 }</span>
        );
      }

      if(this.state.currentPage !== 0)
        paging.unshift(
          <span key="previous"
                onClick={() => this.changePage(Math.max(this.state.currentPage-1,0))}
                className={"pagination-item"}>«</span>);

      if(this.state.currentPage !== (+this.props.paging.totalPages - 1))
        paging.push(
          <span key="next"
                onClick={() => this.changePage(Math.min(this.state.currentPage + 1,+this.props.paging.totalPages))}
                className={"pagination-item"}>»</span>);
    }

    if( items.length === 0 )
      items = <this.props.item itemStyle={ this.props.itemStyle || ''  } empty />;

    return (
      <Container className={"p-0 " + this.props.className} fluid={this.props.full}>
        <this.props.layout { ...this.props.layoutAttributes }>
          { items }
        </this.props.layout>
        {
          this.props.paging &&
          <div className={"pagination-container"}>
            { paging }
          </div>
        }
      </Container>

    );
  }
}

PaginationItemGroup.defaultProps = {
  item: 'SimpleItem'
};



// WEBPACK FOOTER //
// ./src/components/item-group/PaginationItemGroup.js